import CategoryButton from "@/components/CategoryButton";
import { router, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import filterimg from "@/assets/filter-white.svg";
import mapimg from "@/assets/mapimg.svg";
import listimg from "@/assets/listimg.svg";
import { ReactSVG } from "react-svg";

import activityimage from "@/assets/gridimage1.png";
import registerimage from "@/assets/resgisterimage.png";
import eventimage from "../assets/gridimage3.jpeg";
import accomodationbusinessimage from "../assets/gridimage4.jpeg";
import activityimagewebp from "@/assets/gridimage1.webp";
import registerimagewebp from "@/assets/resgisterimage.webp";
import eventimagewebp from "../assets/gridimage3.webp";
import accomodationbusinessimagewebp from "../assets/gridimage4.webp";
import list from "@/assets/list.svg"

import { useEffect, useState } from "react";
import { isGreek } from "@/utils/constants";
import { Button } from "@heroui/react";
import styled from "styled-components";

interface CategoriesFilterProps {
    setSelectedModel: (model: string) => void;
    filters?: boolean;
    setIsFiltersOpen?: (isOpen: boolean) => void;
    setLoading?: (isLoading: boolean) => void;
    setIsMapView?: (isMapView: boolean) => void;
    isMapView?: boolean;
}

const checkWebPSupport = (callback) => {
    const canvas = document.createElement("canvas");
    // Check if the canvas context is available
    if (!canvas.getContext || !canvas.getContext("2d")) {
        callback(false);
        return;
    }

    // Check if WebP is supported
    const isWebPSupported =
        canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;

    callback(isWebPSupported);
};

const StyledDiv = styled.div`

.test { 
::-webkit-scrollbar {
    width: 0px!important;
    height: 0px!important;
  }

  ::-webkit-scrollbar-track {
    background: transparent!important;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent!important;
    border-radius: 0!important;
  }
}

  

`;

const CategoriesFilter: React.FC<CategoriesFilterProps> = ({
    setSelectedModel,
    filters,
    isMapView,
    setIsFiltersOpen,
    setLoading,
    setIsMapView,
}) => {

    const [supportsWebP, setSupportsWebP] = useState(null);
    useEffect(() => {
        checkWebPSupport((supports) => {
            setSupportsWebP(supports);
        });
    }, []);

    const CATEGORY_COLORS = {
        Activity: "#890077",
        Place: "#00668A",
        Event: "#006E0F",
        Accomodation: "#704700",
        Business: "#5600AD",
    };

    const CATEGORY_IMAGES = {
        Activity: supportsWebP ? activityimagewebp : activityimage,
        Place: supportsWebP ? registerimagewebp : registerimage,
        Event: supportsWebP ? eventimagewebp : eventimage,
        Accomodation: supportsWebP
            ? accomodationbusinessimagewebp
            : accomodationbusinessimage,
        Business: supportsWebP
            ? accomodationbusinessimagewebp
            : accomodationbusinessimage,
    };

    const { activeCategories } = usePage().props;
    const { t } = useTranslation(["glossary"]);

    const handleMapListClick = (bool: boolean) => {
        if (bool !== isMapView) {
            const url = new URL(window.location.href);
            const params = url.searchParams;
            setIsMapView(!isMapView);
            params.set("isMapView", !isMapView);
        }
    };

    const handleClick = (model: string) => {
        if (setLoading) {
            setLoading(true);
        }
        setSelectedModel(model);
    };


    const Categories = () => {

        return (
            <StyledDiv className="flex max-xl:space-y-2 max-xl:py-4 lg:justify-center">
                <button
                    className={`relative hover:scale-105 max-xl:top-2 h-10 transition mx-2 py-1 px-4 text-white flex items-center justify-center rounded-lg ${activeCategories === undefined ? 'bg-primary' : 'border-[#49454F] border-1 '}`}
                    title={t('all')}
                    onClick={() => setSelectedModel('all')}
                >
                    <span className={`relative font-semibold ${activeCategories === undefined ? 'text-white' : ' text-[#49454F]'}`}>{t('all')}</span>
                </button>

                {Object.entries(CATEGORY_COLORS).map(
                    ([category, color]) => (
                        <CategoryButton
                            key={category}
                            title={t(category)}
                            image={CATEGORY_IMAGES[category]}
                            onClick={() => handleClick(category)}
                            isActive={activeCategories?.includes(category)}
                            iconColor={color}
                            activeBorderColor={color}
                        />
                    ),
                )}


            </StyledDiv>
        )
    }

    return (
        <div>
            <div className="flex md:space-x-4 p-4 max-md:flex-wrap max-md:gap-2 bg-white shadow justify-between">

                <div className="flex items-center gap-5">
                    <div className="max-xl:hidden">
                        <Categories />
                    </div>

                    {filters && (
                        <Button
                            title={t("filters")}
                            onClick={() => setIsFiltersOpen((prev) => !prev)}
                            className="p-2 h-11 min-w-28 rounded-3xl border-primary border bg-primary"
                        >
                            <div className="flex items-center justify-center space-x-3 !fill-white">
                                <img src={filterimg} />
                                <div className="text-md font-semibold text-white">
                                    {t("filters")}
                                </div>
                            </div>
                        </Button>
                    )}
                </div>

                <div className="flex xl:mt-1.5 mt-0">
                    {/* <div>Button here</div> */}
                    {filters && (
                        <div className="flex items-center">
                            <button
                                title={t("map")}
                                onClick={() => handleMapListClick(true)}
                                className={`p-2 h-11 w-27 rounded-3xl rounded-r-none border-primary border ${isMapView
                                    ? "bg-[#1D26CA] text-white"
                                    : "bg-white text-black"
                                    }`}
                            >
                                <div className="flex space-x-3">
                                    <ReactSVG
                                        src={mapimg}
                                        className="mt-0.5"
                                        beforeInjection={(svg) => {
                                            svg.setAttribute(
                                                "style",
                                                "width: 22px; height: 22px;",
                                            );
                                            svg.querySelectorAll("path").forEach(
                                                (path) => {
                                                    path.setAttribute(
                                                        "fill",
                                                        isMapView
                                                            ? "#FFFFFF"
                                                            : "#1D26CA",
                                                    );
                                                },
                                            );
                                        }}
                                    />
                                    <div className="text-md font-light">
                                        {t("map")}
                                    </div>
                                </div>
                            </button>

                            <button
                                title={t("list")}
                                onClick={() => handleMapListClick(false)}
                                className={`p-2 h-11 w-27 rounded-3xl rounded-l-none border-primary border ${!isMapView
                                    ? "bg-[#1D26CA] text-white"
                                    : "bg-white text-black"
                                    }`}
                            >
                                <div className="flex items-center justify-center space-x-3">

                                    <ReactSVG
                                        src={list}
                                        className="mt-0.5"
                                        beforeInjection={(svg) => {
                                            svg.setAttribute(
                                                "style",
                                                "width: 22px; height: 22px;",
                                            );
                                            svg.querySelectorAll("path").forEach(
                                                (path) => {
                                                    path.setAttribute(
                                                        "fill",
                                                        !isMapView
                                                            ? "#FFFFFF"
                                                            : "#1D26CA",
                                                    );
                                                },
                                            );
                                        }}
                                    />
                                    <div className="text-md font-light">
                                        {t("list")}
                                    </div>
                                </div>
                            </button>
                        </div>
                    )}
                </div>

            </div>

            <div className="xl:hidden overflow-scroll">
                <Categories />
            </div>

        </div>

    );
};

export default CategoriesFilter;
